export const GET_ALL_EMPLOYEE_REQUEST = "GET_ALL_EMPLOYEE_REQUEST";
export const GET_ALL_EMPLOYEE_FAILURE = "GET_ALL_EMPLOYEE_FAILURE";
export const GET_ALL_EMPLOYEE_SUCCESS = "GET_ALL_EMPLOYEE_SUCCESS";

export const CREATE_EMPLOYEE_FAILURE = "CREATE_EMPLOYEE_FAILURE";
export const CREATE_EMPLOYEE_SUCCESS = "CREATE_EMPLOYEE_SUCCESS";
export const CREATE_EMPLOYEE_REQUEST = "CREATE_EMPLOYEE_REQUEST";

export const UPDATE_EMPLOYEE_REQUEST = "UPDATE_EMPLOYEE_REQUEST";
export const UPDATE_EMPLOYEE_FAILURE = "UPDATE_EMPLOYEE_FAILURE";
export const UPDATE_EMPLOYEE_SUCCESS = "UPDATE_EMPLOYEE_SUCCESS";

export const UPDATE_EMPLOYEE_STATUS_REQUEST = "UPDATE_EMPLOYEE_STATUS_REQUEST";
export const UPDATE_EMPLOYEE_STATUS_FAILURE = "UPDATE_EMPLOYEE_STATUS_FAILURE";
export const UPDATE_EMPLOYEE_STATUS_SUCCESS = "UPDATE_EMPLOYEE_STATUS_SUCCESS";

export const DELETE_EMPLOYEE_REQUEST = "DELETE_EMPLOYEE_REQUEST";
export const DELETE_EMPLOYEE_FAILURE = "DELETE_EMPLOYEE_FAILURE";
export const DELETE_EMPLOYEE_SUCCESS = "DELETE_EMPLOYEE_SUCCESS";

export const GET_ALL_EMPLOYEE_PERFORMANCE_REQUEST = "GET_ALL_EMPLOYEE_PERFORMANCE_REQUEST";
export const GET_ALL_EMPLOYEE_PERFORMANCE_FAILURE = "GET_ALL_EMPLOYEE_PERFORMANCE_FAILURE";
export const GET_ALL_EMPLOYEE_PERFORMANCE_SUCCESS = "GET_ALL_EMPLOYEE_PERFORMANCE_SUCCESS";